import React from "react";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { depositStatusChip } from "../../utils";
import classNames from "classnames";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const MiniCard = ({
  icon,
  title,
  date,
  amount,
  receiptsCount,
  actions,
  statusChip,
  message,
  isCheque
}) => {
  return (
    <div
      className={classNames("cm-mini-card", {
        ["cm-mini-card-empty"]: !isCheque && !receiptsCount,
      })}
    >
      <div className="cm-mini-card-header">
        <div
          className={classNames("cm-mini-card-icon", {
            ["cm-mini-card-icon-empty"]: !receiptsCount,
          })}
        >
          {icon}
        </div>
        <div>
          <div className="cm-mini-card-title">{title}</div>
          <div className="cm-mini-card-sub">{date}</div>
        </div>

        <div className="cm-mini-card-right">
          <div className="cm-mini-card-amount">{getFormattedAmount(amount)}</div>
          {receiptsCount > 0 && (
            <div className="cm-mini-card-receipts">
              {receiptsCount} {isCheque ? 'receipts' : 'receipts'}
            </div>
          )}
        </div>
      </div>
      {message && <div className="text-center">{message}</div>}
      <div className="cm-mini-card-footer">
        {actions && actions}
        {statusChip && (
          <CustomChip
            style={{ fontFamily: "Gilroy-Medium" }}
            {...depositStatusChip(statusChip)}
          />
        )}
      </div>
    </div>
  );
};

export default MiniCard;
